import { isEqual } from 'lodash';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button, Input } from 'rizzui';
import DateField from '../../../../../components/forms/DateField';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../../../components/forms/CustomTextDelayInput';

interface RouteHeadquartersFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const RouteHeadquartersFilters: React.FC<RouteHeadquartersFiltersProps> = ({ filters, updateFilters, }) => {

    // RENDER 

    return (
        <>
            <CustomTextDelayInput
                id="search_text"
                label="Búsqueda general"
                placeholder="Buscar por nombre de ruta, descripción o nombre de sede"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="headquarter_name"
                label="Nombre de sede"
                placeholder="Buscar por nombre de sede"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="headquarter_city"
                label="Ciudad de sede"
                placeholder="Buscar por ciudad de sede"
                filters={filters}
                updateFilters={updateFilters}
            />

            <CustomTextDelayInput
                id="headquarter_address"
                label="Dirección de sede"
                placeholder="Buscar por dirección de sede"
                filters={filters}
                updateFilters={updateFilters}
            />

            <Input
                type="number"
                label="Índice de orden"
                placeholder="Buscar por índice de orden"
                value={filters.filter_filters?.orderIndex || ''}
                onChange={(e) => {
                    const value = e.target.value;
                    if (value === '') {
                        updateFilters({ orderIndex: null });
                    } else {
                        updateFilters({ orderIndex: parseInt(value) });
                    }
                }}
                className="w-full"
            />


            <CustomSelect
                isSearchable
                id={'high_season'}
                label="Temporada alta"
                options={[
                    { label: 'Todos', value: 'null' },
                    { label: 'Sí', value: true },
                    { label: 'No', value: false }
                ]}
                onChange={(e: any) => {
                    if (e.value === 'null') {
                        updateFilters({ high_season: null });
                        return;
                    }
                    updateFilters({ high_season: e.value });
                }}
                value={filters.filter_filters?.high_season !== null && filters.filter_filters?.high_season !== undefined
                    ? { label: filters.filter_filters?.high_season ? 'Sí' : 'No', value: filters.filter_filters?.high_season }
                    : { label: 'Todos', value: 'null' }}
            />

            <Input
                type="number"
                label="Días de recogida"
                placeholder="Buscar por días de recogida"
                value={filters.filter_filters?.pick_between_days || ''}
                onChange={(e) => {
                    const value = e.target.value;
                    if (value === '') {
                        updateFilters({ pick_between_days: null });
                    } else {
                        updateFilters({ pick_between_days: parseInt(value) });
                    }
                }}
                className="w-full"
            />
        </>
    );
};

export default RouteHeadquartersFilters;